import MapViewer from "./MapViewer";
import {fullMap} from "./mapHelpers";

window.addEventListener('load', function(){

    let map = new MapViewer({
        zoomControl:false,
        showMenu:false,
        showSearchLocation:false,
        showRoutesList:false,
        freeMode:'events',
        showEventsList:false,
        coordinates: window.mapDefaultCoordinates || {lat: 0, lng: 0}
    });
    map.initMap();

    let container = map.getMapContainer();
    $('#mapWidget .mapWidgetMap').html(container);
    $('.mapWidgetOverlay-changeSize').on('click', function(){
        fullMap(map);
    })

})